import { Component } from '@angular/core';

/**
 * 
 *  created by AHMED HAYEL 
 *
 */

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts